module.exports = __webpack_public_path__ + "media/icons/naped-4x4-active-862cfa37.png";